import axios from 'axios';

export const orchestratorPricingClient = axios.create({
  baseURL: process.env.REACT_APP_ORCHESTRATOR_PRICING_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_ORCHESTRATOR_PRICING_API_KEY as string,
    'Content-Type': 'application/json',
  },
});

export const orchestratorGlobalClient = axios.create({
  baseURL: process.env.REACT_APP_ORCHESTRATOR_GLOBAL_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_ORCHESTRATOR_GLOBAL_API_KEY as string,
    'Content-Type': 'application/json',
  },
});

export const convertEnvStepName = (envStepName: string) => {
  return envStepName.replace(/_/g, ' ').trim();
};

interface CallOrchestratorPricingArgs {
  nid: string;
  status?: string;
  email?: string;
  taskType?: string;
  eventName?: string;
  isRetry?: boolean;
  comment?: string;
  retrySourceName?: string;
  businessType?: string;
  rejectedReason?: string;
  rejectedMessage?: string;
  genericRejectedReason?: string;
}

export const callOrchestratorPricing = async ({
  nid,
  status,
  email,
  taskType,
  eventName,
  isRetry,
  comment,
  retrySourceName,
  businessType,
  rejectedReason,
  rejectedMessage,
  genericRejectedReason,
}: CallOrchestratorPricingArgs) => {
  const resolvedEventName = eventName
    ? eventName
    : convertEnvStepName(process.env.REACT_APP_ORCHESTRATOR_STEP as string);

  // Enviar siempre los campos requeridos para trazabilidad de reintentos.
  const responsePayload: Record<string, unknown> = {
    task_type: taskType,
    owner_process: email,
    retry_policy_by: 'portal_de_aprobologia',
    business_type: businessType,
    ...(rejectedReason && { rejected_reason: rejectedReason }),
    ...(rejectedMessage && { rejected_message: rejectedMessage }),
    ...(genericRejectedReason && {
      generic_rejected_reason: genericRejectedReason,
    }),
  };

  const { data } = await orchestratorPricingClient.post('orchestrator_update', {
    country: localStorage.getItem('country'),
    nid,
    status,
    event_name: resolvedEventName,
    is_retry: isRetry,
    retry_source_name: retrySourceName,
    comment,
    response: responsePayload,
  });
  return data;
};

interface CallRejectedOrchestratorPricingArgs {
  nid: string;
  email: string;
  genericRejectedReason: string;
  eventName?: string; // por defecto "idm aprobologia"
  comment?: string;
}

interface CallRescueOrchestratorArgs {
  nid: string;
  comment?: string;
}

export const callRescueOrchestratorPricing = async ({
  nid,
  comment,
}: CallRescueOrchestratorArgs) => {
  const { data } = await orchestratorGlobalClient.post('event-reception', {
    nid,
    country: localStorage.getItem('country'),
    event_name: 'rescue_apro',
    retry_source_name: 'idm revision de documentos',
    is_retry: true,
    ...(comment && { comment }),
  });
  return data;
};

export const callRejectedOrchestratorPricing = async ({
  nid,
  email,
  genericRejectedReason,
  eventName = 'idm aprobologia',
  comment,
}: CallRejectedOrchestratorPricingArgs) => {
  const { data } = await orchestratorPricingClient.post('orchestrator_update', {
    country: localStorage.getItem('country'),
    nid,
    status: 'REJECTED',
    event_name: eventName,
    comment,
    response: {
      owner_process: email,
      generic_rejected_reason: genericRejectedReason,
    },
  });
  return data;
};
